module.exports = __webpack_public_path__ + "static/media/oblong_b.23677494.svg";